import React, { useEffect } from 'react';
import LoadingNav from './LoadingNav';
import LoadingBars from '../LoadingBars';
import styled from 'styled-components';
import { Box, Horizontal } from 'gls';
import { style } from 'typestyle';

const StyledP = styled.p`
  margin-top: 30px;
`;

export default function LoadingPlaceholderSkeletonPage() {
  useEffect(() => {
    document.querySelector('body')?.classList.add('--loading');

    return () => {
      document.querySelector('body')?.classList.remove('--loading');
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Horizontal>
      <LoadingNav />
      <Box className={contentStyle}>
        <LoadingBars />
        <StyledP>Loading</StyledP>
      </Box>
    </Horizontal>
  );
}

const contentStyle = style({
  paddingTop: '30%',
  paddingLeft: '40%'
})